import en from "@javascripts/shared/localazy.en";
import id from "@javascripts/shared/localazy.id";
import ms from "@javascripts/shared/localazy.ms";
import th from "@javascripts/shared/localazy.th";

export const supportedLang = ['id', 'en', 'ms', 'th']
export const locales = {
  en: en,
  id: id,
  ms: ms,
  th: th,
}
export const controlBarLocales = () => {
  let controlBarLanguages = {}
  supportedLang.forEach((lang) => {
    controlBarLanguages[`${lang}`] = locales[`${lang}`].control_bar
  })
  return controlBarLanguages
}
